var Component = require("!../../../node_modules/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  require("!!../../../node_modules/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-61477ce0\"}!../../../node_modules/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/node_modules/vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/template/index.vue
// module id = 1121
// module chunks = 1